import { SvgIcon, useTheme } from "@mui/material";

const PauseIcon = ({ color, fontSize }: any) => {

    const theme = useTheme();

    return (
        <SvgIcon sx={{ fontSize: fontSize || 32 }}>
            <svg width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 22h6V2H4zM5 3h4v18H5zm9 19h6V2h-6zm1-19h4v18h-4z" fill={color || theme.palette.primary.main} />
                <path fill="none" d="M0 0h24v24H0z"/>
                </svg>

        </SvgIcon>
    );

};

export default PauseIcon;